import React from "react";
import { Card, Col, Empty, Row, Typography, Tag } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";
import { format } from "date-fns";

const { Title, Text } = Typography;

const CampusesTab = ({ institution }) => {
  if (!institution) return null;

  const { campuses = [] } = institution;

  return (
    <div className="pt-4 pb-6">
      {campuses.length === 0 ? (
        <Empty description="No campuses found." className="my-10" />
      ) : (
        <Row gutter={[24, 24]}>
          {campuses.map((campus) => (
            <Col key={campus.id} xs={24} sm={12} md={6}>
              <Card
                // hoverable
                className="transition-all border border-gray-200! hover:shadow-sm"
                bodyStyle={{ padding: "1.5rem" }}
              >
                <div className="space-y-2">
                  <Title level={5} className="mb-2 text-gray-800">
                    <EnvironmentOutlined className="mr-2 text-blue-500" />
                    {campus.location}
                  </Title>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default CampusesTab;
